function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M23,28.7c-0.2,0-0.3,0-0.5-0.1l-11.3-3.3c-0.5-0.2-0.8-0.7-0.6-1.2c0.1-0.3,0.3-0.5,0.6-0.6l11.3-3.3 c0.3-0.1,0.6-0.1,1,0l11.3,3.3c0.5,0.2,0.8,0.7,0.6,1.2c-0.1,0.3-0.3,0.5-0.6,0.6l-11.3,3.3C23.3,28.7,23.2,28.7,23,28.7z  M13.8,24.5l9.2,2.7l9.2-2.7L23,21.8L13.8,24.5z M34.4,25.1L34.4,25.1z M22.8,21L22.8,21z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M23,34.6c-0.2,0-0.5-0.1-0.6-0.2c-1.8-1.2-3.8-1.8-5.9-1.9c-0.5,0-0.9-0.4-0.9-0.9v-5.6 c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8v5c2.1,0.2,4.1,0.8,5.9,1.9c1.8-1.1,3.8-1.8,5.9-2v-5c0-0.4,0.3-0.8,0.7-0.9 c0.4,0,0.8,0.3,0.9,0.7c0,0.1,0,0.1,0,0.2v5.6c0,0.5-0.4,0.9-0.9,0.9c-2.1,0.1-4.1,0.7-5.9,1.9C23.4,34.6,23.2,34.6,23,34.6z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8,36.8c-0.5,0-0.9-0.3-1-0.8L2.4,11.8c-0.1-0.5,0.3-1.1,0.8-1.2c0.5-0.1,1.1,0.3,1.2,0.8L9,35.6 c0.1,0.5-0.3,1.1-0.8,1.2C8.2,36.8,8.1,36.8,8,36.8z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M3.4,12.6c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.3-0.5-1-0.2-1.4c0.2-0.2,4.1-5.3,15.2-7.5c1.7-0.3,3.4-0.5,5-0.6 c0.5,0,1,0.4,1.1,0.9c0,0.6-0.4,1-0.9,1.1c-1.5,0.1-3.1,0.3-4.7,0.6c-10.4,2-14,6.7-14,6.7C4,12.5,3.7,12.6,3.4,12.6z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.8,19.9c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.3-0.5-1-0.2-1.4c0.2-0.2,4.1-5.3,15.2-7.5c1.7-0.3,3.4-0.5,5-0.6 c0.5,0,1,0.4,1.1,0.9c0,0.6-0.4,1-0.9,1.1c-1.5,0.1-3.1,0.3-4.7,0.6c-10.4,2-14,6.7-14,6.7C5.4,19.7,5.1,19.9,4.8,19.9z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M36.2,16.7c-0.2,0-0.4,0-0.5-0.1c0,0-4.3-2.5-12.7-1.5c-0.5,0.1-1-0.3-1.1-0.9c-0.1-0.5,0.3-1,0.9-1.1 c4.6-0.5,8-0.1,10.3,0.4c-1.2-1.1-2.1-1.3-2.1-1.3c-0.4-0.1-0.7-0.4-0.8-0.8c-0.1-0.4,0.1-0.8,0.4-1l2.3-1.7 C31.1,8,28,7.3,23.4,7.6c-0.5,0-1-0.4-1.1-0.9s0.4-1,0.9-1.1c7.8-0.5,11.8,1.9,12,2c0.3,0.2,0.5,0.5,0.5,0.8c0,0.3-0.1,0.6-0.4,0.8 L33,10.9c1.1,0.7,2.5,1.9,4,4.2c0.3,0.4,0.2,0.9-0.1,1.2C36.7,16.6,36.4,16.7,36.2,16.7z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M22.8,15c-0.2,0-0.3,0-0.5-0.1c-0.5-0.2-0.7-0.9-0.4-1.3l1.3-2.5l-1.3-6.9c-0.1-0.5,0.3-1.1,0.8-1.2 c0.5-0.1,1.1,0.3,1.2,0.8l1.5,7.6l-1.6,3.2C23.5,14.8,23.2,15,22.8,15z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 21.6,
  y: 11.5,
  transform: "matrix(0.9823 -0.1874 0.1874 0.9823 -1.9943 4.4589)",
  width: 2,
  height: 2.5
}));

function SvgCmsGradFairGradProgramLinks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cms-grad-fair-grad-program-links_svg__cms-grad-fair-grad-program-links_svg__Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgCmsGradFairGradProgramLinks;